<template>
  <main-container>
    <a-card :title="weight + 'kg 设置'">
      <table style="margin-top: 20px;width: 100%;" v-if="form">
        <thead class="ant-table-thead">
          <tr>
            <th class="ant-table-row-cell-last">国家/地区</th>
            <th class="ant-table-row-cell-last">实际价格€</th>
            <th class="ant-table-row-cell-last">销售价格€</th>
            <th class="ant-table-row-cell-last">一级会员价格</th>
            <th class="ant-table-row-cell-last">二级会员价格</th>
            <th class="ant-table-row-cell-last">三级会员价格</th>
            <th class="ant-table-row-cell-last">四级会员价格</th>
            <th class="ant-table-row-cell-last">五级会员价格</th>
          </tr>
        </thead>
        <tbody class="ant-table-tbody">
          <tr class="ant-table-row ant-table-row-level-0" :key="item" v-for="item in keys">
            <td style="text-transform: uppercase">{{ item }}</td>
            <td>
              <a-input-number :min="0" :value="getValue(item)" @change="handlePriceChange($event, item)" />
            </td>
            <td>
              <a-input-number
                style="width: 70px; margin-right: 12px"
                :min="0"
                :value="getValue(item, 'r')"
                @change="handlePriceChange($event, item, 'r')"
              />
              <a-input-number
                style="width: 70px"
                :min="0"
                :value="getValue(item, 'v')"
                @change="handlePriceChange($event, item, 'v')"
              />
            </td>
            <td>
              <a-input-number
                style="width: 70px; margin-right: 12px"
                :min="0"
                :value="getValue(item, 'level', 1)"
                @change="handlePriceChange($event, item, 'level', 1)"
              />
              <a-input-number
                style="width: 70px"
                :min="0"
                :value="getValue(item, 'level_v', 1)"
                @change="handlePriceChange($event, item, 'level_v', 1)"
              />
            </td>
            <td>
              <a-input-number
                style="width: 70px; margin-right: 12px"
                :min="0"
                :value="getValue(item, 'level', 2)"
                @change="handlePriceChange($event, item, 'level', 2)"
              />
              <a-input-number
                style="width: 70px"
                :min="0"
                :value="getValue(item, 'level_v', 2)"
                @change="handlePriceChange($event, item, 'level_v', 2)"
              />
            </td>
            <td>
              <a-input-number
                style="width: 70px; margin-right: 12px"
                :min="0"
                :value="getValue(item, 'level', 3)"
                @change="handlePriceChange($event, item, 'level', 3)"
              />
              <a-input-number
                style="width: 70px"
                :min="0"
                :value="getValue(item, 'level_v', 3)"
                @change="handlePriceChange($event, item, 'level_v', 3)"
              />
            </td>
            <td>
              <a-input-number
                style="width: 70px; margin-right: 12px"
                :min="0"
                :value="getValue(item, 'level', 4)"
                @change="handlePriceChange($event, item, 'level', 4)"
              />
              <a-input-number
                style="width: 70px"
                :min="0"
                :value="getValue(item, 'level_v', 4)"
                @change="handlePriceChange($event, item, 'level_v', 4)"
              />
            </td>
            <td>
              <a-input-number
                style="width: 70px; margin-right: 12px"
                :min="0"
                :value="getValue(item, 'level', 5)"
                @change="handlePriceChange($event, item, 'level', 5)"
              />
              <a-input-number
                style="width: 70px"
                :min="0"
                :value="getValue(item, 'level_v', 5)"
                @change="handlePriceChange($event, item, 'level_v', 5)"
              />
            </td>
          </tr>
        </tbody>
      </table>
      <div style="padding-top: 20px;display: flex;justify-content: space-around;">
        <a-button type="primary" @click="savePrice" :loading="loading">
          保存
        </a-button>
      </div>
    </a-card>
  </main-container>
</template>

<script>
import Service from '@/api/service';
export default {
  name: 'ServicePriceDetail',

  data() {
    return {
      weight: 0,
      form: undefined,
      loading: false,
      keys: ['35', '38', '51', '52', 'es', 'pt', '07'],
      keyName: {
        35: 'p_35',
        38: 'p_38',
        51: 'p_51',
        52: 'p_52',
        es: 'es_price',
        pt: 'pt_price',
        '07': 'p_07',
      },
    };
  },

  mounted() {
    const priceDetail = this.$store.state.price.priceDetail;

    if (!priceDetail) {
      this.$router.replace({ name: this.$routeName.serviceList });
    }

    this.weight = priceDetail.weight;
    this.form = {
      id: priceDetail.id,
      p_35: priceDetail.p_35,
      p_35_r: priceDetail.p_35_r,
      level_35: priceDetail['35_level'],
      p_38: priceDetail.p_38,
      p_38_r: priceDetail.p_38_r,
      level_38: priceDetail['38_level'],
      p_51: priceDetail.p_51,
      p_51_r: priceDetail.p_51_r,
      level_51: priceDetail['51_level'],
      p_52: priceDetail.p_52,
      p_52_r: priceDetail.p_52_r,
      level_52: priceDetail['52_level'],
      es_price: priceDetail.es_price,
      es_price_r: priceDetail.es_price_r,
      level_es: priceDetail.es_level,
      pt_price: priceDetail.pt_price,
      pt_price_r: priceDetail.pt_price_r,
      level_pt: priceDetail.pt_level,
      p_07: priceDetail.p_07,
      p_07_r: priceDetail.p_07_r,
      level_07: priceDetail['07_level'],
    };
  },

  methods: {
    handlePriceChange(price, key, type = '', level = undefined) {
      if (type === '') {
        this.form[this.keyName[key]] = price;
      } else if (type === 'r') {
        this.form[this.keyName[key] + '_r'] = price;
      } else if (type === 'v') {
        this.form[this.keyName[key] + '_r'] = this.v2R(price);
      } else if (type === 'level') {
        this.form[`level_${key}`][`${key}_${level}`] = price;
      } else if (type === 'level_v') {
        this.form[`level_${key}`][`${key}_${level}`] = this.v2R(price);
      }
    },

    getValue(key, type = '', level = undefined) {
      if (type === '') {
        return this.form[this.keyName[key]];
      } else if (type === 'r') {
        return this.form[this.keyName[key] + '_r'];
      } else if (type === 'v') {
        return this.r2V(this.form[this.keyName[key] + '_r']);
      } else if (type === 'level') {
        return this.form[`level_${key}`][`${key}_${level}`];
      } else if (type === 'level_v') {
        return this.r2V(this.form[`level_${key}`][`${key}_${level}`]);
      }
    },

    savePrice() {
      this.loading = true;

      const form = { ...this.form };

      this.keys.forEach(key => {
        form[`level_${key}`] = JSON.stringify(form[`level_${key}`]);
      });

      Service.setServicePrice(form)
        .then(res => {
          if (res.status === 'success') {
            this.$message.success('保存成功');
            this.$router.back();
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },

    r2V(value) {
      return (parseFloat(value) * 1.21).toFixed(2);
    },

    v2R(value) {
      return (parseFloat(value) / 1.21).toFixed(2);
    },
  },
};
</script>

<style scoped></style>
